export default {"src":"/_next/static/media/white-blob-2.ba168c51.svg","height":551,"width":196};